import React from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MuiButton from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { globalWaitingReviewRoute } from 'routes';

const useStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${theme.palette.grey[400]}`
  },
  // primaryButtonRoot: {
  //   fontSize: '0.75rem',
  //   borderRadius: 0,
  //   paddingLeft: theme.spacing(2),
  //   paddingRight: theme.spacing(2)
  // },
  arrowDownButton: {
    padding: '6px 16px',
    border: '1px solid',
    letterSpacing: '0.02857em',
    textTransform: 'upperCase',
    fontSize: '0.875rem',
    color: 'rgba(0, 0, 0, 0.87)',
    transition: '1s, transform 2s',
    borderRadius: '4px',
    lineHeight: 1.75,
    fontWeight: 500,
    backgroundColor: '#e0e0e0',
    boxShadow:
      '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    borderColor: '#e0e0e0',
    '&:hover': {
      backgroundColor: '#d5d5d5',
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
      borderColor: '#d5d5d5'
      // boxShadow: 'none',
    }
  }
}));

const GoBackButton = () => {
  const history = useHistory();
  const localClasses = useStyles();

  function navigateBack() {
    history.goBack();
    // return <Redirect to={globalWaitingReviewRoute()} />
  }

  return (
    <MuiButton
      variant="outlined"
      color="primary"
      startIcon={<ArrowBackIcon />}
      classes={{ root: localClasses.arrowDownButton }}
      onClick={navigateBack}
    >
      Back
    </MuiButton>
  );
};

export default GoBackButton;
